import { createContext, useContext, type FC, type ReactNode } from 'react';

type ServerVarsContextType = {
    isBot?: boolean;
    isDesktop?: boolean;
    isMobile?: boolean;
    isTablet?: boolean;
};

export const ServerVarsContext = createContext<ServerVarsContextType>({});

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

type ServerVarsProviderProps = {
    children: ReactNode;
} & ServerVarsContextType;

export const ServerVarsContextProvider: FC<ServerVarsProviderProps> = ({
    children,
    isBot,
    isDesktop,
    isMobile,
    isTablet,
}) => {
    return (
        <ServerVarsContext
            value={{
                isBot,
                isDesktop,
                isMobile,
                isTablet,
            }}
        >
            {children}
        </ServerVarsContext>
    );
};

export const useServerVarsContext = (): ServerVarsContextType => {
    return useContext(ServerVarsContext);
};
